import React from 'react';
import styled from '@emotion/styled';
import { Flex } from 'src/components';
import { colors } from 'src/theme';
import { mediaQuery } from 'src/common';

const StatNumber = styled.span({
  fontFamily: '"Red Hat Display", sans-serif',
  fontWeight: 700,
  fontSize: 24,
  lineHeight: '28px',
  color: colors.white,
});

const StatLabel = styled.span({
  fontFamily: '"Red Hat Display", sans-serif',
  fontWeight: 300,
  fontSize: 16,
  lineHeight: '20px',
  color: colors.white,
});

export interface StatCardProps {
  number: string | number;
  label: string;
}

export const StatCard: React.FC<StatCardProps> = ({ number, label }) => (
  <Flex align="center" gap={8}>
    <StatNumber>{number}</StatNumber>
    <StatLabel>{label}</StatLabel>
  </Flex>
);

// Stats Bar Container Component
const StatsBarStyle = styled(Flex)({
  width: '100%',
  backgroundColor: colors.primary1,
  padding: '16px 24px',
  justifyContent: 'center',
  alignItems: 'center',

  [mediaQuery('laptopL')]: {
    padding: '16px 188px',
  },
});

export interface StatsBarProps {
  children: React.ReactNode;
}

export const StatsBar: React.FC<StatsBarProps> = ({ children }) => (
  <StatsBarStyle>
    <Flex justify="center" wrap="wrap" gap={24}>
      {children}
    </Flex>
  </StatsBarStyle>
);
